import Components from "slotworks/components/components";
import RevolverBigWins from "slotworks/integration/revolver/states/revolver-big-wins";
import betModel from "slotworks/model/bets/bet-model";
import gameState from "slotworks/model/game-state";
import State from "slotworks/state-machine/states/state";
import Contract from "slotworks/utils/contract";
import WheelBonusRecord from "integration/records/wheel-bonus-record";
import Layers from "slotworks/graphics/layers/layers";
import campaignsModel from "slotworks/integration/revolver/model/campaigns-model";

export default class BonusWheelBigWins extends State {

    private static TICK_TIME = 750;

    private onComplete: Function;

    public onEnter(cascadeSkip: boolean) {
        if (gameState.getCurrentGame().inFreespinsGame) {
            this.complete();
            return;
        }

        if (!cascadeSkip) {
            this.onComplete = () => this.complete();

            const wasPromoVisible = Layers.PromoBetBar.container.visible;

            const record = gameState.getCurrentGame().getCurrentRecord() as WheelBonusRecord;
            const winnings = record.totalCreditsWon;

            const stake = betModel.getTotalBet();

            this.start(winnings, stake).then((bigWin) => {
                if (wasPromoVisible && bigWin && campaignsModel.isFreespinsActive()) {
                    Layers.PromoBetBar.show();
                    Layers.SmartButton.show();
                }
                if (bigWin) {
                    Components.betBar.winnings.setWinnings(0, winnings, BonusWheelBigWins.TICK_TIME);
                }
                if (this.onComplete) {
                    this.onComplete();
                }
            });
        }

        const freespins = campaignsModel.freespins;
        if (freespins) {
            try {
                Components.promoBetBar.setTotalWin(freespins.totalWin);
            } catch (e) {
                /**/
            }
        }
    }

    public start(winnings: number, stake: number): Contract<boolean> {
        return Components.bigWin.showWin(winnings, stake);
    }

}